module.exports = __webpack_public_path__ + "static/img/11.da4f8d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/sp/11.png
// module id = WwtY
// module chunks = 0